<template>
    <div class="container">
        <div class="auth-wrap">
            <div class="banner">               
            </div>
            
            <v-tabs v-model="activeTab" grow slider-color="rgb(227, 117, 54,1)" bg-color="rgb(227, 117, 54,0.25)">
                <v-tab v-for="(tab, index) in tabs" :key="index" :to="tab.route">
                    {{ tab.title }}
                </v-tab>
            </v-tabs>
            
       
            <div>
                <slot />
            </div>
           
        </div>
    </div>
</template>





<script lang="ts">
export default {
  data() {
    return {
      activeTab: null,
      tabs: [
        { title: '學期課表', route: '/course' },
        { title: '請假缺課', route: '/abslea' },
        { title: '操行獎懲', route: '/prapun' },
        // Add more tabs as needed
      ],
    };
  },
};
</script>